import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { FileSizePipe } from '@pipes/file-size.pipe';
import { Papa, } from 'ngx-papaparse';
import { Observable, of, throwError, } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "ngx-papaparse";
import * as i2 from "@ngx-translate/core";
import * as i3 from "../pipes/file-size.pipe";
var MAX_CSV_FILE_SIZE = 50 * 1024 * 1024; // TODO:  50MB set on actual magic number
export var ICSVParseErrorType;
(function (ICSVParseErrorType) {
    ICSVParseErrorType["Quotes"] = "Quotes";
    ICSVParseErrorType["Delimiter"] = "Delimiter";
    ICSVParseErrorType["FieldMismatch"] = "FieldMismatch";
    ICSVParseErrorType["FieldError"] = "FieldError";
})(ICSVParseErrorType || (ICSVParseErrorType = {}));
export var ICSVParseErrorCode;
(function (ICSVParseErrorCode) {
    ICSVParseErrorCode["MissingQuotes"] = "MissingQuotes";
    ICSVParseErrorCode["UndetectableDelimiter"] = "UndetectableDelimiter";
    ICSVParseErrorCode["TooFewFields"] = "TooFewFields";
    ICSVParseErrorCode["TooManyFields"] = "TooManyFields";
    ICSVParseErrorCode["InvalidQuotes"] = "InvalidQuotes";
    ICSVParseErrorCode["InvalidData"] = "InvalidData";
    ICSVParseErrorCode["MissingData"] = "MissingData";
})(ICSVParseErrorCode || (ICSVParseErrorCode = {}));
var CSVParser = /** @class */ (function () {
    function CSVParser(_parseService, _translateService, _fileSizePipe) {
        this._parseService = _parseService;
        this._translateService = _translateService;
        this._fileSizePipe = _fileSizePipe;
    }
    CSVParser.prototype.parseFile = function (file, config) {
        var _this = this;
        var maxSize = config ?
            (config.maxFileSize || MAX_CSV_FILE_SIZE) :
            MAX_CSV_FILE_SIZE;
        if (file.size > maxSize) {
            return throwError(this._translateService.instant("file_size_too_large", {
                maxSize: this._fileSizePipe.transform(maxSize, 0),
            }));
        }
        return new Observable(function (subscriber) {
            _this._parseService.parse(file, tslib_1.__assign({ complete: function (response) {
                    subscriber.next(response);
                    subscriber.complete();
                }, error: function (err) { return subscriber.error(err.toString()); } }, config));
            return function () { subscriber.complete(); };
        }).pipe(mergeMap(function (result) {
            var maxRows = !!config && config.maxRows || 0;
            return maxRows && result.data.length > maxRows ?
                throwError(_this._translateService.instant("csv_parse_too_many_records", {
                    records: result.data.length,
                    max: maxRows,
                })) :
                of(result);
        }));
    };
    CSVParser.prototype.generateFile = function (items) {
        return this._parseService.unparse(items, {
            delimiter: ';',
        });
    };
    CSVParser.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CSVParser_Factory() { return new CSVParser(i0.ɵɵinject(i1.Papa), i0.ɵɵinject(i2.TranslateService), i0.ɵɵinject(i3.FileSizePipe)); }, token: CSVParser, providedIn: "root" });
    return CSVParser;
}());
export { CSVParser };
